define.alias("ember-cli-string-helpers/helpers/dasherize", "calendar/helpers/dasherize");